module.exports = __webpack_public_path__ + "img/story-reactnative.3b5c7777.svg";